<template>
	<div class="main">
		<header class="panel-heading">
			<h3 class="panel-title">{{this.sessionData.accountType == "STU" && this.sessionData.isRoomMage != "Y"?"打掃點":"打掃點稽核"}}</h3>
		</header>
		<section class="panel panel-default" style="margin-bottom: 0px;">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a id="openSearch" href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
			<div id="searchArea" class="panel-collapse collapse">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-6">
							<label class="col-md-4">打掃情形</label>
							<div class="col-md-8">
								<select v-model="qryParam.situation" >
									<option value="">--請選擇--</option>
									<option value="未掃">未掃</option>
									<option value="稍髒">稍髒</option>
									<option value="尚可">尚可</option>
									<option value="乾淨">乾淨</option>
								</select>
							</div>
						</div>
						<div class="col-md-6">
							<label class="col-md-4">複掃結果</label>
							<div class="col-md-8">
								<select v-model="qryParam.agResult">
									<option value="">--請選擇--</option>
									<option value="未掃">未掃</option>
									<option value="稍髒">稍髒</option>
									<option value="尚可">尚可</option>
									<option value="乾淨">乾淨</option>
								</select>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-6">
							<label class="col-md-4">查詢日期</label>
							<div class="col-md-8">
								<datepicker :format="customFormatter" :language="zh" v-model="qryParam.cleanDate" input-class="form-control" :style="{width:'auto', display:'inline-block'}"/>
							</div>
						</div>
						<div class="col-md-6"></div>
					</div>
					<div class="row form-group">
						<div class="col-md-offset-4 col-md-4 ">
							<div class="col-md-offset-4 col-md-4">
								<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<div class="tab-content">
			<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
				<div class="row" v-if="isAdmin('stay')">
					<div class="col-md-12 text-right">
						<button class="btn s_btn_b" @click="genCleanAudit">產生名單</button>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-12">
						<table class="table table-no-more table-bordered table-striped mb-none" >
							<thead>
								<tr v-if="isAdmin('stay')">
									<th class="text-center" width="10%">房棟</th>
									<th class="text-center" width="5%">樓層</th>
									<th class="text-center" width="10%">打掃點</th>
									<th class="text-center" width="15%">打掃情形</th>
									<th class="text-center" width="15%">複掃結果</th>
									<th class="text-center" width="15%">檢查/複查時間</th>
									<th class="text-center" width="15%">打掃負責寢室</th>
									<th class="text-center" width="15%">歷史紀錄</th>
								</tr>
								<tr v-else>
									<th class="text-center" width="15%">打掃點</th>
									<th class="text-center" width="15%">打掃情形</th>
									<th class="text-center" width="15%">複掃結果</th>
									<th class="text-center" width="20%">檢查/複查時間</th>
									<th class="text-center" width="20%">打掃負責寢室</th>
									<th class="text-center" width="15%">歷史紀錄</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in cleanAuditList" :key="index">
									<td data-title="房棟" class="text-center" v-if="isAdmin('stay')">{{item.house}}</td>
									<td data-title="樓層" class="text-center" v-if="isAdmin('stay')">{{item.flood}}</td>
									<td data-title="打掃點" class="text-center">{{item.cleanLocation}}</td>
									<td data-title="打掃情形" class="text-center">
										<button type="button" class="btn btn-danger" @click="isShowPopup=true; auditId=item.id; auditType='1';" v-if="!item.situation && sessionData.isRoomMage == `Y` && !isAdmin('stay')">填寫</button>
										<span v-else>{{item.situation}}</span><br/>
										<a :href="`/upload/${item.proofFile}`" target="_blank" v-if="item.proofFile">打掃情形</a>
									</td>
									<td data-title="複掃結果" class="text-center">
										<button type="button" class="btn btn-danger" @click="isShowPopup=true; auditId=item.id; auditType='2'; " v-if="(item.situation == '未掃' || item.situation == '稍髒') && (item.agResult != '尚可' && item.agResult != '乾淨') && sessionData.isRoomMage == `Y` && !isAdmin('stay')">填寫</button>
										<span v-if="(item.agResult == '尚可' || item.agResult == '乾淨')">
											{{item.agResult}}<br/>
											<a :href="`/upload/${item.agProofFile}`" target="_blank" v-if="item.agProofFile">複掃結果</a>
										</span>
									</td>
									<td data-title="檢查/複查時間" class="text-center">
										<span v-if="item.resultDateStr">{{`(一)${item.resultDateStr}`}}</span>
										<span v-if="item.agResultDateStr">{{`(二)${item.agResultDateStr}`}}</span>
									</td>
									<td data-title="打掃負責寢室" class="text-center">{{item.staffBedFloodRoom}}</td>
									<td data-title="歷史紀錄" class="text-center">
										<a href="javascript:;" class="btn btn-danger" @click="isShowHisPopup=true; hisList=item.hisList">歷史紀錄</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12">
						<div class="text-center" >
							<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
						</div>
					</div>
				</div>
			</div>
		</div>
		<auditPopup v-if="isShowPopup" :id="auditId" :type="auditType"></auditPopup>
		<auditHisPopup v-if="isShowHisPopup" :hisList="hisList" />
	</div>
</template>
<script>
import auditPopup from './auditPopup';
import auditHisPopup from './auditHisPopup';
export default {
	components:{
		auditPopup,
		auditHisPopup
	},
	data(){
		return {
			qryParam:{
				cleanDate: this.dateFormatter(new Date()),
				situation:"",
				agResult:""
			},
			cleanAuditList:[],
			page:1,
			totalPage:0,
			isShowPopup:false,
			isShowHisPopup:false,
			auditId:"",
			auditType:"",
			hisList:[]
		};
	},
	mounted(){
		this.gridInit();
	},
	methods:{
		updateGrid(page) {
			//更新Grid 必需
			this.page = page;
			this.gridInit();
		},
		gridInit(){
			const api = "/api/Environment/cleanAuditList";
			this.$axios.post(api, JSON.stringify({
				model:this.qryParam,
				page:this.page,
				pageSize:10
			})).then(resp => {
				this.cleanAuditList = resp.data.data;
			});
		},
		genCleanAudit(){
			const api = "/api/Environment/generateDailyCleanAudit";
			this.$axios.get(api).then(resp => {
			});
		},
		showPopupControl(isOpen){
			if(isOpen == false){
				this.auditId = "";
			}
			this.isShowPopup = isOpen;
		},
		showHisPopupControl(isOpen){
			if(isOpen == false){
				this.hisList = [];
			}
			this.isShowHisPopup = isOpen;
		}
	}
}
</script>